import { useOutletContext } from "react-router-dom";
import { Agent } from "~/services/agents";
import AgentConversationTable from "./AgentConversationTable";

export const AgentConversationsTab = () => {
  const agent = useOutletContext<Agent>();
  return (
    <div className="flex h-full flex-col gap-4">
      <h2 className="text-2xl font-semibold">Sessions</h2>
      <AgentConversationTable agentId={agent.id} />
    </div>
  );
};
